import { Token } from '@uniswap/sdk-core'
import { FeeAmount } from '@uniswap/v3-sdk'
import { USDC_TOKEN, WETH_TOKEN } from './libs/constant'
 
// Example Configuration
 
export const CurrentConfig = {
  rpc: {
    local: 'http://localhost:3001',
    mainnet: 'https://mainnet.infura.io/v3/22503b481540401b8760d93cf85d7964',
  },
  tokens: {
    in: USDC_TOKEN,
    amountIn: 500,
    out: WETH_TOKEN,
    poolFee: FeeAmount.MEDIUM,
  },
}